<div class="qr-detail core-screen">
  @if (showSearch()) {
  <section class="qr-search">
    @if (!embeddedInCabinetPage()) {
    <h1 class="qr-detail__title">{{ 'admin.staffQrScan.title' | translate }}</h1>
    }
    <p class="muted">{{ 'STAFF.CABINET.SCAN.LEAD' | translate }}</p>
    @if (isWebPlatform) {
    <p class="qr-search__desktop-hint">
      {{ 'admin.staffQrScan.desktopUnsupported' | translate }}
    </p>
    }
    <lib-not-input
      type="text"
      [placeholder]="'STAFF.CABINET.SCAN.INPUT_LABEL' | translate"
      [ariaLabel]="'STAFF.CABINET.SCAN.INPUT_LABEL' | translate"
      [ngModel]="manualCode()"
      (ngModelChange)="manualCode.set($event)"
      [hideErrorBlock]="true"
    />
    <div class="qr-search__actions">
      <lib-not-button
        [text]="'STAFF.CABINET.SCAN.SUBMIT' | translate"
        [color]="'#140342'"
        [bgColor]="'#E8F9F7'"
        [action]="{ type: 'action' }"
        (actionEvent)="submitManualCode()"
      />
      @if (!isWebPlatform) {
      <lib-not-button
        [text]="'admin.scanQR' | translate"
        [color]="'#0B6270'"
        [bgColor]="'#DCF6F2'"
        [action]="{ type: 'action' }"
        (actionEvent)="scanWithCamera()"
      />
      }
    </div>
  </section>
  } @else if (loading()) {
  <div class="state-message">{{ 'admin.staffQrScan.loading' | translate }}</div>
  } @else if (errorKey(); as errKey) {
  <div class="state-message state-message--error">{{ errKey | translate }}</div>
  } @else {
  <div class="qr-detail__inner">
    @if (kind() === 'box' && box(); as b) {
    <h1 class="qr-detail__title">
      {{ 'admin.staffQrScan.kindBox' | translate }}
    </h1>
    <p class="mono qr-detail__id">{{ b.id }}</p>
    <dl class="kv">
      <dt>{{ 'admin.staffQrScan.status' | translate }}</dt>
      <dd>{{ storageStatusLabel(b.status) }}</dd>
      <dt>{{ 'admin.staffQrScan.owner' | translate }}</dt>
      <dd>{{ ownerLine() }}</dd>
      <dt>{{ 'admin.staffQrScan.address' | translate }}</dt>
      <dd>
        {{ addressLabel() || ('admin.staffQrScan.noAddress' | translate) }}
      </dd>
    </dl>
    <section class="section">
      <h2 class="section__title">{{ 'admin.staffQrScan.contents' | translate }}</h2>
      @if (boxItems().length === 0) {
      <p class="muted">{{ 'admin.staffQrScan.noContents' | translate }}</p>
      } @else {
      <ul class="item-list">
        @for (it of boxItems(); track it.id) {
        <li>{{ it.name }}</li>
        }
      </ul>
      }
    </section>
    } @else if (kind() === 'item' && item(); as it) {
    <h1 class="qr-detail__title">{{ 'admin.staffQrScan.kindItem' | translate }}</h1>
    <p class="mono qr-detail__id">{{ it.id }}</p>
    <dl class="kv">
      <dt>{{ 'admin.staffQrScan.status' | translate }}</dt>
      <dd>{{ storageStatusLabel(it.status) }}</dd>
      <dt>{{ 'admin.staffQrScan.owner' | translate }}</dt>
      <dd>{{ ownerLine() }}</dd>
      @if (it.is_standalone && !it.box_id) {
      <dt>{{ 'admin.staffQrScan.address' | translate }}</dt>
      <dd>
        {{ addressLabel() || ('admin.staffQrScan.noAddress' | translate) }}
      </dd>
      }
      @if (it.description) {
      <dt>{{ 'admin.staffQrScan.itemDescription' | translate }}</dt>
      <dd>{{ it.description }}</dd>
      }
    </dl>
    @if (parentBox(); as pb) {
    <section class="section">
      <h2 class="section__title">{{ 'admin.staffQrScan.itemInBoxHint' | translate }}</h2>
      <p class="mono">{{ pb.id }}</p>
      <dl class="kv kv--tight">
        <dt>{{ 'admin.staffQrScan.status' | translate }}</dt>
        <dd>{{ storageStatusLabel(pb.status) }}</dd>
        <dt>{{ 'admin.staffQrScan.address' | translate }}</dt>
        <dd>
          {{ pb.location_code || ('admin.staffQrScan.noAddress' | translate) }}
        </dd>
      </dl>
    </section>
    }
    }

    @if (kind() === 'item' && canOpenItemDetail()) {
    <section class="section section--actions">
      <div class="actions">
        <button
          type="button"
          class="btn-primary"
          [disabled]="itemDetailLoading()"
          (click)="openItemDetail()"
        >
          {{ 'admin.staffQrScan.openItemDetail' | translate }}
        </button>
      </div>
    </section>
    }

    @if (showReceiveProfileBlock()) {
    <section class="section section--actions">
      <p class="muted">{{
        'admin.users.items.receiveProfileNotVerifiedHint' | translate
      }}</p>
    </section>
    }

    @if (canReceiveToWarehouse()) {
    <section class="section section--actions">
      <div class="actions">
        <button
          type="button"
          class="btn-primary"
          [disabled]="receiving()"
          (click)="receiveToWarehouse()"
        >
          {{ 'admin.staffQrScan.receiveToWarehouse' | translate }}
        </button>
      </div>
    </section>
    }

    @if (orderLinkId()) {
    <section class="section">
      <h2 class="section__title">{{ 'admin.staffQrScan.order' | translate }}</h2>
      @if (order(); as ord) {
      <p class="mono">{{ ord.id }}</p>
      <p class="muted">
        {{ orderStatusLabel(ord.status) }}
      </p>
      } @else {
      <p class="mono">{{ orderLinkId() }}</p>
      }
      <button type="button" class="linkish" (click)="openOrder()">
        {{ 'admin.staffQrScan.openOrder' | translate }}
      </button>
    </section>
    }

    @if (isWarehouseWorker() && primaryBox()) {
    <section class="section section--actions">
      <h2 class="section__title">{{ 'admin.staffQrScan.warehouseActionsHint' | translate }}</h2>
      <div class="actions">
        <button
          type="button"
          class="btn-primary"
          [disabled]="!canWarehouseMove()"
          (click)="goMoveBox()"
        >
          {{ 'admin.staffQrScan.move' | translate }}
        </button>
        <button
          type="button"
          class="btn-secondary"
          [disabled]="!canWarehouseClear()"
          (click)="confirmClearPlacement()"
        >
          {{ 'admin.staffQrScan.clearPlacement' | translate }}
        </button>
      </div>
    </section>
    }

    @if (isWarehouseWorker() && kind() === 'item' && item()?.is_standalone && !item()?.box_id) {
    <section class="section section--actions">
      <h2 class="section__title">{{ 'admin.staffQrScan.warehouseActionsHint' | translate }}</h2>
      <div class="actions">
        <button
          type="button"
          class="btn-primary"
          [disabled]="!canWarehouseMoveItem()"
          (click)="goMoveItem()"
        >
          {{ 'admin.staffQrScan.move' | translate }}
        </button>
        <button
          type="button"
          class="btn-secondary"
          [disabled]="!canWarehouseClearItem()"
          (click)="confirmClearItemPlacement()"
        >
          {{ 'admin.staffQrScan.clearPlacement' | translate }}
        </button>
      </div>
    </section>
    }
  </div>
  }
</div>
